import type { ColumnDef } from '@/shared/types/table-filters.types';
import type { CompanyRoleName, CompanyUser } from '../types/company-admin.types';

/** The roles a company admin assigns; SUPER_ADMIN never reaches this list. */
const COMPANY_ROLES: CompanyRoleName[] = ['ADMIN', 'MANAGER', 'AGENT'];

/** Filterable/sortable company user fields, shared by the desktop table and the mobile cards. */
export const companyUserTableColumns: ColumnDef<CompanyUser>[] = [
  {
    key: 'fullName',
    label: 'Name',
    filterType: 'text',
    accessor: (user) => user.fullName,
    sortable: true,
  },
  {
    key: 'email',
    label: 'Email',
    filterType: 'text',
    accessor: (user) => user.email,
    sortable: true,
  },
  {
    key: 'roles',
    label: 'Roles',
    filterType: 'multi-select',
    accessor: (user) => user.roles,
    options: COMPANY_ROLES,
    sortable: true,
  },
  {
    key: 'isActive',
    label: 'Active',
    filterType: 'boolean',
    accessor: (user) => user.isActive,
    sortable: true,
  },
  {
    key: 'lastLoginAt',
    label: 'Last login',
    filterType: 'date-range',
    accessor: (user) => user.lastLoginAt,
    sortable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    filterType: 'date-range',
    accessor: (user) => user.createdAt,
    sortable: true,
  },
];
